import { PageHeader } from '@components/page-header/page-header';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';
import './stop.scss';
import { useTranslation } from '@translations';

export const Stop = () => {
    const { stop } = useTranslation();

    return (
        <div className="stop-container">
            <RichIcon type={RichIconTypes.HAAND_HEIHEI} maxHeight={190} />
            <PageHeader header={stop.header} ingress={stop.ingress} />
        </div>
    );
};
